import { AppFacade } from './app.facade';
import { OfflineFacade } from './offline.facade';
import { UserDetailsFacade } from './user-details.facade';

export { AppFacade, OfflineFacade, UserDetailsFacade };

export const facades = [AppFacade, OfflineFacade, UserDetailsFacade];
